import React, { useState, useEffect } from 'react';
import ProjectItem from './ProjectItem';
import portadaSintv from './images/PortadaSintv.webp';
import portadaBould from './images/portadabould.webp';
import portadaAE from './images/portadaAE.webp';
import portadaDMP from './images/portadaDMP.webp';
import portadaCH from './images/portadaCH.webp';

const Work = () => {
  const dummyProjects = [
    {
      id: 0,
      title: "D' MANUEL P",
      image: portadaDMP,
      category: "Graphic Design",
    },
    {
      id: 1,
      title: "CLEANHITS",
      image: portadaCH,
      category: "3D Modeling",
    },
    {
      id: 2,
      title: "ACOMA ENERGY",
      image: portadaAE,
      category: "Web Development",
    },
    {
      id: 3,
      title: "BOULD",
      image: portadaBould,
      category: "UI/UX Design",
    },
    {
      id: 4,
      title: "SINTV",
      image: portadaSintv,
      category: "UI/UX Design",
    },
  ];

  const getGridStyle = () => {
    const width = window.innerWidth;
    let columns;
    if (width <= 768) {
      columns = '1fr'; // Mobile devices
    } else if (width > 768 && width <= 1024) {
      columns = 'repeat(2, 1fr)'; // Tablets and medium screens
    } else {
      columns = 'repeat(3, 1fr)'; // Laptops and larger screens
    }

    return {
      display: 'grid',
      gridTemplateColumns: columns,
      gap: '0.5rem',
      maxWidth: '100vw',
      margin: '0 auto',
      padding: '1rem',
    };
  };

  const [gridStyle, setGridStyle] = useState(getGridStyle());

  useEffect(() => {
    const handleResize = () => {
      setGridStyle(getGridStyle());
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={gridStyle}>
      {dummyProjects.map((project) => (
        <ProjectItem key={project.id} project={project} />
      ))}
    </div>
  );
};

export default Work;
